import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetLanguagesQuery } from '../../../store/apis/dictionaries/languages';
import { useGetLanguageLevelsQuery } from '../../../store/apis/dictionaries/languages-levels';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetLanguageLevelsQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Уровни владения языками')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.languageLevels}
    />
  );
};

export default List;
